import type { DatabaseAsset, ProcessActivityAsset, S3Asset } from '@common/validation/processActivityAsset';
import { AssetContentType } from '@common/enums';

// Not every `AssetContentType` is technically a MIME type (e.g. `image/jpg` and `image/tif`), but for backwards
// compatibility non-official MIME types are also supported.
export function getAssetUrl(mimeType: string): string {
    switch (mimeType) {
        case AssetContentType.applicationPdf:
            return '/assets/svg/icon-pdf.svg';
        case AssetContentType.doc:
        case AssetContentType.docx:
            return '/assets/svg/icon-doc.svg';
        case AssetContentType.imageHeic:
        case AssetContentType.imageHeif:
            // HEIC is actually a type of HEIF, but there is no HEIF icon so use the HEIC icon as fallback
            return '/assets/svg/icon-heic.svg';
        case AssetContentType.imageJpeg:
        case AssetContentType.imageJpg:
            return '/assets/svg/icon-jpg.svg';
        case AssetContentType.imagePng:
            return '/assets/svg/icon-png.svg';
        case AssetContentType.imageTif:
        case AssetContentType.imageTiff:
            return '/assets/svg/icon-tiff.svg';
        case AssetContentType.mov:
            return '/assets/svg/icon-mov.svg';
        case AssetContentType.mp4:
            return '/assets/svg/icon-mp4.svg';
        case AssetContentType.ppt:
        case AssetContentType.pptx:
            return '/assets/svg/icon-ppt.svg';
        case AssetContentType.xls:
        case AssetContentType.xlsx:
            return '/assets/svg/icon-xls.svg';
        default:
            // There is no default icon, so use the PDF icon as this was the previous default as well
            return '/assets/svg/icon-pdf.svg';
    }
}

export function isDatabaseAsset(asset: ProcessActivityAsset): asset is DatabaseAsset {
    return typeof asset.id !== 'undefined' && typeof asset.s3Id === 'undefined';
}

export function isS3Asset(asset: ProcessActivityAsset): asset is S3Asset {
    return typeof asset.id === 'undefined' && typeof asset.s3Id !== 'undefined';
}

export function isProcessActivityAssets(assets: unknown): assets is ProcessActivityAsset[] {
    return Array.isArray(assets) && assets.every((asset) => isDatabaseAsset(asset) || isS3Asset(asset));
}
